import { useEffect } from 'react';
import metaTags from '../../../meta-tags';

const Meta = ({ section = 'home' }) => {
  useEffect(() => {
    const tags = metaTags[section] ?? metaTags.home;
    document.title = tags.title;
    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', tags.description);
    }
    const keywordsTag = document.querySelector('meta[name="keywords"]');
    if (keywordsTag) {
      keywordsTag.setAttribute('content', tags.keywords);
    }
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    const ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogTitleTag) ogTitleTag.setAttribute('content', tags.title);
    if (ogDescTag) ogDescTag.setAttribute('content', tags.description);
    const twitterTitleTag = document.querySelector('meta[property="twitter:title"]');
    const twitterDescTag = document.querySelector('meta[property="twitter:description"]');
    if (twitterTitleTag) twitterTitleTag.setAttribute('content', tags.title);
    if (twitterDescTag) twitterDescTag.setAttribute('content', tags.description);
  }, [section]);
  return null;
};

export default Meta; 